var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('receipt-order',{ref:"receiptOrder",attrs:{"order-status-data":_vm.orderStatusData,"refundable":_vm.refundable,"storer-data":_vm.storerData},on:{"rowClick":_vm.rowClick}}),_c('receipt-detail',{ref:"receiptDetail",staticStyle:{"margin-top":"2px"},attrs:{"refundable":_vm.refundable},on:{"rowDblClick":_vm.rowDblClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }